import {IMAGES} from '../../../../../constants/assetLists';
import {useClientsContext} from '../../../../../context/clients/ClientsContextProvider';

function FormDialogHeader() {
  const {selectedClient} = useClientsContext();

  return (
    <div className="w-full h-[56px] bg-darkBlue flex justify-between items-center">
      {/* Selected Location Icon */}
      <div className="w-[160px] h-[56px] bg-white flex justify-center items-center">
        <img
          src={
            (selectedClient as any)?.icon
              ? (selectedClient as any)?.icon
              : IMAGES.placeholder
          }
          alt="location"
          className="w-full max-h-[50px] object-contain"
        />
      </div>

      {/* App Logo */}
      <div className="w-[140px] h-[24px] me-5">
        <img
          src={IMAGES.logo}
          alt="logo"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}

export default FormDialogHeader;
